import { service } from '../axios';
export function getSettingConfigurations(params) {
    return service({ url: '/configurations/getPage', method: 'get', params });
}
export function getConfigValue(params) {
    return service({ url: '/configurations/getConfigValue', method: 'get', params });
}
export function getAllConfigValue(params) {
    return service({ url: '/configurations/getAllConfigValue', method: 'get', params });
}
export function saveConfiguration(data) {
    return service({ url: '/configurations/save', method: 'post', data });
}
export function deleteSettingConfiguration(data) {
    return service({ url: '/configurations/delete', method: 'Delete', data });
}
